import { Locale } from '~/models/Locale'
import { TranslationService } from '~/services/Translation'

const DEFAULT_LOCALE = 'en'
const LOCALE_SEGMENT_PATTERN = /^[a-z]{2}(?:-[A-Za-z]{2})?$/

export function resolveLocale(locale: Locale): string {
	const supportedLocales: Set<Locale> = new Set(TranslationService.availableLanguagesList())
	if (supportedLocales.has(locale)) return locale

	const language = locale.split('-')[0] as Locale
	if (language && supportedLocales.has(language)) return language

	return DEFAULT_LOCALE
}

export function resolveLocaleFallbackPath(path: string): string | null {
	const segments = path.split('/').filter(Boolean) as Locale[]
	const [locale, ...rest] = segments
	if (!locale || !LOCALE_SEGMENT_PATTERN.test(locale)) return null

	const supportedLocales = new Set(TranslationService.availableLanguagesList())
	if (supportedLocales.has(locale)) return null

	const fallbackLocale = resolveLocale(locale)
	return `/${[fallbackLocale, ...rest].join('/')}`
}

export default defineNuxtRouteMiddleware((to) => {
	const fallbackPath = resolveLocaleFallbackPath(to.path)
	if (!fallbackPath || fallbackPath === to.path) return

	return navigateTo(
		{
			path: fallbackPath,
			query: to.query,
			hash: to.hash,
		},
		{ redirectCode: 302 }
	)
})
